import { Component } from '@angular/core';
import { NavController, Events, IonicPage } from 'ionic-angular';
import { UtiltiyProvider } from '../../providers/utiltiy/utiltiy';
import { CrudProvider } from '../../providers/crud/crud';
@IonicPage()
@Component({
  selector: 'page-klmr-news',
  templateUrl: 'klmr-news.html',
})
export class KlmrNewsPage {
  horizontalText: any = "";
  newsLiist: any = [];
  information:any = [];

  obj:any = {
    "items": [{
        "name": "Test",
        "children": [{
          "name": "Test",
          "information": "waeawewaea",
          "price": "321"
        }]
      },
      {
        "name": "Test-01",
        "children": [{
          "name": "Test-01",
          "information": "waeawewaea-01",
          "price": "321-01"
        }]
      },
      {
        "name": "Test-03",
        "children": [{
          "name": "Test-03-01",
          "children": [{
            "name": "Test-03-01",
            "information": "waeawewaea",
            "price": "321-03-01"
          },
          {
            "name": "Test-03-02",
            "information": "waeawewaea",
            "price": "321-03-02"
          }
        ]
        }]
      }
    ]
  };
  constructor(public navCtrl: NavController, public utility: UtiltiyProvider, private api: CrudProvider, public events: Events) {
    this.getNews();

    this.information = this.obj.items;
    // this.navCtrl.swipeBackEnabled = false;
  }

  async getStatus() {
    this.horizontalText = ``;

  }

  getNews() {
    this.newsLiist = [];
    let string = "";
    this.api.get("/prestart/news/News_get", "false")
      .then((result: any) => {
        result.result.forEach(element => {
          string = string + `Subject: ${element.subject} Date: ${element.date} By:${element.username}     `

        });
        this.horizontalText = string;
        this.newsLiist = result.result;
        console.log("result", this.newsLiist)
        console.log("this.horizontalText ", this.horizontalText)
      }, err => {
      })
  }

  dateConvert(date) {

    if (date) {
      let dateString = date.split("-");
      return dateString[2] + "-" + dateString[1] + "-" + dateString[0]
    } else {
      return "";
    }

  }


  toggleSection(i){
    this.information[i].open = !this.information[i].open;
  }

  toggleItem(i,j){
    this.information[i].children[j].open = ! this.information[i].children[j].open;
  }

  buyItem(item){
    console.log(item)
  }
}


// WEBPACK FOOTER //
// ./src/pages/klmr-news/klmr-news.ts